import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { DeadlineLabelComponent } from "@webapp/shared/components/deadline-label/deadline-label.component";

@NgModule({
  imports: [CommonModule, LocalizationModule],
  declarations: [DeadlineLabelComponent],
  exports: [DeadlineLabelComponent],
})
export class DeadlineLabelModule {}
